module.exports = __webpack_public_path__ + "public/img/icon_znyingxiao.ac8c865c.png";